module.exports = __webpack_public_path__ + "img/in_front.be5030ca.webp";